<template>
  <section class="purchase-orders-filters">
    <div class="section-title">
      <span @click="isOpen = !isOpen">
        {{ $t('purchaseOrders.listing.filters.title') }}
        <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
      </span>
    </div>
    <div v-show="isOpen">
      <div class="filter-inputs">
        <div class="filters-label">
          {{ $t('purchaseOrders.listing.labels.status') | uppercase }}
        </div>
        <TolSelect
          :options="purchaseOrdersStatusesList"
          :placeholder="$t('purchaseOrders.listing.labels.status')"
          @change="onPurchaseOrdersStatusFilterChange"
        />
        <div class="date-range-label">
          {{ $t('purchaseOrders.listing.labels.type') | uppercase }}
        </div>
        <TolSelect
          :options="purchaseOrdersTypesList"
          :placeholder="$t('purchaseOrders.listing.labels.type')"
          @change="onPurchaseOrdersTypeFilterChange"
        />
      </div>
    </div>
  </section>
</template>
<script>
import TolSelect from '@/app/components/TolSelect';
import { PurchaseOrdersListingActions } from '../purchase-orders-listing.keys';
export default {
  components: {
    TolSelect
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    purchaseOrdersStatusesList() {
      let returnValue = [];
      Object.keys(this.$t('purchaseOrders.listing.filters.purchaseOrdersStatuses')).forEach(arg => {
        returnValue.push({
          label: this.$t('purchaseOrders.listing.filters.purchaseOrdersStatuses.' + arg),
          value: arg
        });
      });
      return returnValue;
    },
    purchaseOrdersTypesList() {
      let returnValue = [];
      Object.keys(this.$t('purchaseOrders.listing.filters.purchaseOrderColorTypes')).forEach(
        arg => {
          returnValue.push({
            label: this.$t('purchaseOrders.listing.filters.purchaseOrderColorTypes.' + arg),
            value: arg
          });
        }
      );
      return returnValue;
    }
  },
  methods: {
    onPurchaseOrdersStatusFilterChange(selectedValue) {
      this.$store.dispatch(
        PurchaseOrdersListingActions.PurchaseOrdersFilterPreferenceUpdate,
        selectedValue
      );
    },
    onPurchaseOrdersTypeFilterChange(selectedValue) {
      this.$store.dispatch(
        PurchaseOrdersListingActions.PurchaseOrdersTypeFilterPreferenceUpdate,
        selectedValue
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';
.purchase-orders-filters {
  background-color: $background-level-2;

  .section-title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.22px;
    line-height: 25px;
    margin-bottom: 20px;
    padding: 60px;
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
    }
  }

  .filter-inputs {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0px 60px 60px 60px;

    .filters-label {
      padding-bottom: 5px;
      display: inline-block;
      margin: 0 10px;
    }
  }
}
</style>
